import { IFetchFavoriesResult, IPanelScope } from "@/interfaces";
import { HttpService } from "./http.service";
import { FOLDERS_TAB_KEY } from "@/constants";
import { FavoriteItem } from "@/types";

export const fetchFavories = async ({
  projectId,
  tab,
  module,
}: IPanelScope): Promise<IFetchFavoriesResult> => {
  return await HttpService.get(
    `/projects/${projectId}/favorites/${tab}?entity_name=${module}`,
  );
};

export const saveFavorite = async (
  scope: IPanelScope,
  data: FavoriteItem[],
) => {
  const payload =
    scope.tab === FOLDERS_TAB_KEY
      ? {
          folders: data.map((i) => {
            return { id: i.id, index: i.index };
          }),
        }
      : {
          filters: data.map((i) => {
            return { id: i.id, index: i.index };
          }),
        };

  await HttpService.post(
    `/projects/${scope.projectId}/favorites/set?entity_name=${scope.module}`,
    payload,
  );
};
